import './styles.scss'
import React, { useEffect, useState } from 'react'
import { useHistory, useParams } from 'react-router-dom'
import { I18n } from 'react-redux-i18n'

import { botConsole } from 'api'
import Tabs from './Tabs'
import TabContent from './TabContent'
import Nixi1Spinner from 'components/Nixi1Spinner'

const ConsoleFAQ = () => {
  const { location, push } = useHistory()
  const { assistantId } = useParams()
  const [botHeader, setBotHeader] = useState(null)
  const [assistants, setAssistants] = useState([])
  const [loadingVaList, setLoadingVaList] = useState(true)
  const [loadingBotHeader, setLoadingBotHeader] = useState(true)
  const [errorMessageVaList, setErrorMessageVaList] = useState(null)
  const [errorMessageBotHeader, setErrorMessageBotHeader] = useState(null)
  const [faqToScroll, setFaqToScroll] = useState('')

  useEffect(() => {
    getVaList()
    if (!assistantId && sessionStorage.getItem('va')) selectAssistant(sessionStorage.getItem('va'))
  }, [])

  useEffect(() => {
    if(assistantId) getBotHeader(assistantId)
  }, [assistantId])

  useEffect(() => {
    if (assistantId) {
      if (assistants.length && !assistants.some(assistant => assistant.consoleId === assistantId)) selectAssistant(assistants[0].consoleId)
    } else {
      if (assistants.length) selectAssistant(assistants[0].consoleId)
    }
  }, [assistants, assistantId])

  useEffect(() => {
    if (faqToScroll) {
      const faqNode = document.getElementById(faqToScroll)
      faqNode.scrollIntoView({ behavior: 'smooth' })
    }
  }, [faqToScroll])

  const selectAssistant = (assistantId) => {
    const currentPathname = location.pathname
    const nextPathname = assistantId ? `${location.pathname.split('console')[0]}console/${assistantId}` : `${location.pathname.split('console')[0]}console`

    if (currentPathname !== nextPathname) push(nextPathname)

    if (assistantId) sessionStorage.setItem('va', assistantId)
  }

  const getVaList = async () => {
    setErrorMessageVaList(null)
    setLoadingVaList(true)

    try {
      const { data } = await botConsole.getVaList()
      setAssistants(data.result)
    } catch (error) {
      setErrorMessageVaList(I18n.t('botConsole_error_message_back'))
    }

    setLoadingVaList(false)
  }

  const getBotHeader = async (assistId = assistantId) => {
    try {
      setErrorMessageBotHeader(null)
      setLoadingBotHeader(true)
      const { data } = await botConsole.getBotHeader(assistId)
      setBotHeader(data)
    } catch (error) {
      setErrorMessageBotHeader(I18n.t('botConsole_error_message_back'))
    } finally {
      setLoadingBotHeader(false)
    }
  }

  return (
    <div className='virtual-assistant animated fadeIn'>
      {loadingVaList ? (
        <div className='wrapper'>
          <Nixi1Spinner width={'25px'} height={'25px'} />
        </div>
      ) : !errorMessageVaList
        ? (
          <>
            <Tabs
              setBotHeader={setBotHeader}
              botHeader={botHeader}
              assistants={assistants}
              setAssistants={setAssistants}
              selectAssistant={selectAssistant}
            />
            <TabContent
              botHeader={botHeader}
              getBotHeader={getBotHeader}
              setFaqToScroll={setFaqToScroll}
              loading={loadingBotHeader}
              errorMessage={errorMessageBotHeader}
            />
          </>
        ) : (
          <div className='wrapper'>
            <p className='error-message'>{errorMessageVaList}</p>
          </div>
        )
      }
    </div>
  )
}

export default ConsoleFAQ
